import React from 'react';

export const Loading = (props) => {
    return (
        <div className="cssload-loader">
            <div className="cssload-loader-indicator">
                <ul>
                    <li/>
                    <li/>
                    <li/>
                    <li/>
                    <li/>
                    <li/>
                </ul>
            </div>
            <p className="text-center body-sm body-lighter">{ props.message || 'Cargando ...' }</p>
        </div>
    );

}

export default Loading;
